import React, { useState } from 'react';

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Gallery images from original site
  const galleryImages = [
    {
      url: 'https://static.wixstatic.com/media/b9040e_6fad400ce2d94b34a7a7ed253de55e99~mv2.jpg',
      title: 'Amazing Catch',
      category: 'Fishing'
    },
    {
      url: 'https://static.wixstatic.com/media/b9040e_af27fa25bbf14346aaee61f8be996883~mv2.jpg',
      title: 'Trophy Fish',
      category: 'Fishing'
    },
    {
      url: 'https://static.wixstatic.com/media/b9040e_6aae7dd12dd54a969204931ea6c6a7e6~mv2.jpg',
      title: 'Big Halibut',
      category: 'Fishing'
    },
    {
      url: 'https://static.wixstatic.com/media/b9040e_0e7fc1db83fe43adabe0a89de9332d45~mv2.jpg',
      title: 'Screaming Eagle',
      category: 'Boats'
    },
    {
      url: 'https://static.wixstatic.com/media/b9040e_6f02979753ad4f299ecfc0a6911e2c5a~mv2.jpg',
      title: 'Island Life',
      category: 'Island'
    },
    {
      url: 'https://static.wixstatic.com/media/b9040e_34a0aed848b845e18560898ba9292a0d~mv2.jpg',
      title: 'Captain Luc',
      category: 'Crew'
    },
    {
      url: 'https://static.wixstatic.com/media/b9040e_50daaf2c1363477a803c8f6adef64d99~mv2.jpg',
      title: 'Captain Joel',
      category: 'Crew'
    },
    {
      url: 'https://static.wixstatic.com/media/b9040e_8b1553af0bcc4fceb26c346748ba8c31~mv2.jpg',
      title: 'Seahorse Boat',
      category: 'Boats'
    },
    {
      url: 'https://static.wixstatic.com/media/nsplsh_556976477a494468567977~mv2_d_3500_2333_s_2.jpg',
      title: 'Beautiful Scenery',
      category: 'Nature'
    },
    {
      url: 'https://static.wixstatic.com/media/b9040e_2e6d2f7e02154fd9a21c44be05835643~mv2.jpg',
      title: 'Fishing Adventure',
      category: 'Fishing'
    },
    {
      url: 'https://static.wixstatic.com/media/b9040e_0d0971c1bf0043fe8b97cf9092b95d33~mv2.png',
      title: 'Hot Springs',
      category: 'Tours'
    },
    {
      url: 'https://static.wixstatic.com/media/b9040e_6a5441974a7c48318810144816aafcba~mv2.png',
      title: 'Island Tours',
      category: 'Tours'
    },
    // New images uploaded by client
    {
      url: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/zn1pojk5_IMG_3788.JPG',
      title: 'Coastal Beauty',
      category: 'Nature'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/z69khqg0_IMG_3839.JPG',
      title: 'Island Adventure',
      category: 'Island'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/c4neih2y_IMG_3841.JPG',
      title: 'Scenic Waters',
      category: 'Nature'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/6nprh4iw_IMG_4200.JPG',
      title: 'Fishing Memories',
      category: 'Fishing'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/6me1bh22_IMG_4488.JPG',
      title: 'Ocean Views',
      category: 'Nature'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/7fmvzkky_IMG_4489.JPG',
      title: 'Tofino Waters',
      category: 'Island'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/vw95mjpg_IMG_4526.JPG',
      title: 'Coastal Experience',
      category: 'Tours'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/i07n6e9z_IMG_4964.JPG',
      title: 'Charter Adventures',
      category: 'Boats'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/rgviazso_IMG_1229%202.jpeg',
      title: 'Island Tour Experience',
      category: 'Tours'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/ltxy781z_IMG_1274%202.jpeg',
      title: 'Exploring Tofino',
      category: 'Island'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/smimq13m_IMG_1356.jpeg',
      title: 'Island Adventures',
      category: 'Tours'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/ggjaddz8_IMG_1476.jpeg',
      title: 'Nature Exploration',
      category: 'Nature'
    },
  ];

  // Duplicate images as requested
  const allImages = [...galleryImages, ...galleryImages];

  const categories = ['All', ...new Set(galleryImages.map(img => img.category))];
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredImages = activeCategory === 'All' 
    ? allImages 
    : allImages.filter(img => img.category === activeCategory);

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative h-[50vh] bg-gradient-to-r from-[#5DADE2] to-[#87CEEB] flex items-center justify-center">
        <div className="absolute inset-0 opacity-30">
          <img
            src="https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/zn1pojk5_IMG_3788.JPG"
            alt="Gallery Hero"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative text-center text-white px-4">
          <h1 className="text-5xl md:text-6xl brand-script mb-4" data-testid="gallery-hero-title">
            Gallery 📸
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Oh, the fishing memories we've made! Check out our amazing adventures!
          </p>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-8 bg-white sticky top-20 z-40 shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                  activeCategory === category
                    ? 'bg-gradient-to-r from-[#20B2AA] to-[#5DADE2] text-white shadow-lg scale-105'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
                data-testid={`filter-${category.toLowerCase()}`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 bg-gradient-to-b from-white to-[#F5F5F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredImages.map((image, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
                onClick={() => setSelectedImage(image)}
                data-testid={`gallery-image-${index}`}
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={image.url}
                    alt={image.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-4 text-white w-full">
                    <h3 className="text-lg font-bold">{image.title}</h3>
                    <p className="text-sm opacity-90">{image.category}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
          data-testid="lightbox-modal"
        >
          <div className="relative max-w-6xl max-h-[90vh]">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-12 right-0 text-white text-4xl hover:text-[#FF69B4] transition-colors"
              data-testid="close-lightbox-btn"
            >
              ×
            </button>
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="max-w-full max-h-[85vh] object-contain rounded-lg"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6 text-white">
              <h3 className="text-2xl font-bold">{selectedImage.title}</h3>
              <p className="text-lg opacity-90">{selectedImage.category}</p>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-[#FF69B4] to-[#FFB6C1] text-white">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Want to Create Your Own Memories? 🌟
          </h2>
          <p className="text-xl mb-8">
            Book your adventure today and become part of our gallery!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/charters"
              className="bg-white text-[#FF69B4] px-8 py-4 rounded-full text-lg font-semibold hover:scale-105 transition-transform shadow-lg"
              data-testid="gallery-cta-charters"
            >
              Book a Charter 🎟️
            </a>
            <a
              href="mailto:joel@fishingtofino.net"
              className="bg-white text-[#20B2AA] px-8 py-4 rounded-full text-lg font-semibold hover:scale-105 transition-transform shadow-lg"
              data-testid="gallery-cta-contact"
            >
              Contact Us 📧
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GalleryPage;